import { Link, Popover, Typography } from '@one-thd/sui-atomic-components';
import { InfoFilled } from '@one-thd/sui-icons';
import React, { useState } from 'react';
import { pushEventInfo } from '../../utils/analytics';
export var PerksSpend = function (totalData) {
    var _a;
    var _b = useState(null), anchorEl = _b[0], setAnchorEl = _b[1];
    var open = Boolean(anchorEl);
    var id = open ? 'simple-popover' : undefined;
    return (React.createElement("div", { "data-testid": "perksSpend" },
        React.createElement("div", { className: "sui-flex" },
            React.createElement(Typography, { variant: "body-base", weight: "bold" }, "Perks Spend:"),
            React.createElement("div", { className: "sui-ml-1" }, totalData === null ? (React.createElement(Typography, { variant: "body-base" }, "----")) : (React.createElement("div", { className: "sui-flex sui-gap-2" },
                React.createElement(Typography, { variant: "body-base" },
                    "$", (_a = totalData === null || totalData === void 0 ? void 0 : totalData.proxtraSpend) === null || _a === void 0 ? void 0 :
                    _a.toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                    }),
                    ' ',
                    "in ", totalData === null || totalData === void 0 ? void 0 :
                    totalData.year),
                React.createElement(InfoFilled, { style: { marginTop: '4px', cursor: 'pointer' }, size: "small", color: "info", onClick: function (event) {
                        pushEventInfo({
                            category: { primaryCategory: 'button submission' },
                            eventInfo: { eventName: 'my account settings' },
                            myAccount: {
                                settings: 'purchase history: perk spend tooltip',
                            },
                        });
                        setAnchorEl(event.currentTarget);
                    } }),
                React.createElement(Popover, { id: id, open: open, anchorEl: anchorEl, onClose: function () { return setAnchorEl(null); }, placement: "bottom", title: "Qualifying Perks Spend", offset: "loose" },
                    ' ',
                    React.createElement("div", { className: "sui-w-[219px] sui-mt-3" },
                        React.createElement(Typography, { variant: "body-base" },
                            "Includes transactions made with ProXtra ID or registered tender used at time of checkout. Prior transactions will not be included. ",
                            React.createElement("br", null),
                            "Excluded taxes, shipping fees, returns and gift card purchases.",
                            React.createElement("br", null),
                            React.createElement("br", null),
                            " For full details, see the",
                            ' ',
                            React.createElement(Link, { href: "https://www.homedepot.com/c/ProXtra_TermsandConditions" },
                                "ProXtra Program Terms",
                                React.createElement("br", null),
                                " & Conditions"))))))))));
};
